import { createSlice } from "@reduxjs/toolkit";
import {
  getSubscriptionDetails,
  getSubscriptions,
} from "store/actions/subscriptionsSlice";

const initialState = {
  loading: false,
  isLoading: false,
  perPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  subscriptions: [],
  subscriptionDetails: {},
  filters: {
    keyword: "",
    dates: [],
    sortField: "",
    sortDirection: "asc",
    organizationId: "",
    status: -1,
    orderBy: -1,
  },
};

const subscriptions = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    setSortedSubscriptions: (state, action) => {
      state.subscriptions = action.payload;
    },
    setKeyword: (state, action) => {
      state.filters.keyword = action.payload;
    },
    setDates: (state, action) => {
      state.filters.dates = action.payload;
    },
    setSortConfig: (state, action) => {
      const { field, direction } = action.payload;
      state.filters.sortField = field;
      state.filters.sortDirection = direction;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
    updateSubscriptionsFilterState: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubscriptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.subscriptions = data || [];
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getSubscriptions.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getSubscriptionDetails.pending, (state) => {
        state.loading = true;
        state.subscriptionDetails = {};
      })
      .addCase(getSubscriptionDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.subscriptionDetails = data || {};
        }
      })
      .addCase(getSubscriptionDetails.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default subscriptions.reducer;

export const {
  setSortedSubscriptions,
  setKeyword,
  setDates,
  setSortConfig,
  resetFilters,
  updateSubscriptionsFilterState,
} = subscriptions.actions;
